import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-painel-ajuda',
  templateUrl: './painel-ajuda.component.html',
  styleUrls: ['./painel-ajuda.component.scss']
})
export class PainelAjudaComponent implements OnInit {

  @Input() texto: string;
  @Input() mostrar: boolean;
  @Input() itens: any;

  constructor() { }

  ngOnInit() {
  }

}
